import RecentWinners from './RecentWinners';

export default RecentWinners;